import { useField, useFormikContext } from 'formik'
import { isValid, isDate } from 'date-fns'
import { DatePicker } from '@mui/x-date-pickers'

const FormDatePicker = ({ 'data-testid': testId, ...props }) => {
  const [field, meta] = useField(props)
  const { setFieldValue } = useFormikContext()

  return (
    <DatePicker
      inputFormat="dd/MM/yyyy"
      slotProps={{
        textField: {
          inputProps: { 'data-testid': testId },
          error: meta.touched && !!meta.error,
          helperText: meta.touched && meta.error,
          onChange: (date) => {
            if (isValid(date)) {
              setFieldValue(field.name, date)
            } else {
              setFieldValue(field.name, null)
            }
          },
        },
      }}
      {...field}
      value={field.value}
      onChange={(value) => {
        // Explicitly check for a valid date
        if (isDate(value)) {
          if (value.getFullYear() > 1900) {
            setFieldValue(field.name, value)
          } else {
            // return invalid date
            setFieldValue(field.name, new Date('foo'))
          }
        } else {
          setFieldValue(field.name, null)
        }
      }}
      {...props}
    />
  )
}

export default FormDatePicker
